module.exports = __webpack_public_path__ + "static/media/SoLogo.9c0670ac.png";